import React, { useState, useEffect } from "react";
import UserPanel from "../Dashboard/UserPanel";
import { Container, Row, } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useMachine } from "../../context/MachineContext";
import Select from "react-select";
const TraceabilityAssemblyProduction = () => {
  const authToken = localStorage.getItem("access");
  const location = useLocation();
  const navigate = useNavigate();
  const machine = location.state?.part;
  // const [selectedChildPart, setSelectedChildPart] = useState("");
  const [machines, setMachines] = useState([]);
  const [submittedAssemblies, setSubmittedAssemblies] = useState([]);
const [unusedAssemblies,setUnusedAssemblies] =useState([]);
  //const { selectedMachineId } = useMachine();
  const [boxNumbers, setBoxNumbers] = useState({});
  const selectedOperator_name = localStorage.getItem('name')
  const selectedOperator_id = localStorage.getItem('id')
  const selectedMachineId = localStorage.getItem('selectedMachineId');
  const [selectedMachine, setSelectedMachine] = useState(machine?.machine_id || selectedMachineId);
  const [operators, setOperators] = useState([]);
  const [childPartData, setChildPartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchMachine();
  }, []);
  const fetchMachine = async () => {
    try {
      const response = await fetch("https://api.hanoch.in/api/machines");
      if (response.ok) {
        const machines = await response.json();
    
        setMachines(machines?.data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const selectedMachineObject = machines.find(m => m.id == selectedMachine);
  const isManual = selectedMachineObject?.manual ?? false;
  const selectedChildPart = selectedMachineObject?.parts;

  const [partsMData, setPartsMData] = useState({
    good_parts: 1,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    machine: "machine name",
    part: "part name",
    part_number: 0,
  });


  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    // console.log( `${year}-${month}-${day}`,'yyyyyyy');
    return `${year}-${month}-${day}`;
  };
  const [selectedDate, setSelectedDate] = useState(() => machine?.date || getTodayDate());


  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };

  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();
    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(() => machine?.shift || getCurrentShift());

  const fetchChildParts = async () => {
    try {
      setIsLoading(true);
      // Fetch data from your API
      const response = await fetch(`https://api.hanoch.in/api/parts/children/${selectedChildPart}/`, {

      });

      if (response.ok) {
        const data = await response.json();
        console.log("this is child part data", data);
        setChildPartData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
    finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (selectedChildPart) {
      fetchChildParts()

    }
  }, [selectedChildPart]);
  useEffect(() => {
    if (selectedChildPart && selectedDate && selectedMachine && selectedShift && selectedOperator_id) {
fetchUsedChildPartAssemblies();
      fetchAssemblies();
    }
  }, [selectedChildPart, selectedDate, selectedMachine, selectedShift]);
  const handleEdit = (entry) => {
    // pre-fill input field with serials to edit
    const updatedBoxNumbers = entry.box_serials.map(b => b.serial_number).join(", ");
    setBoxNumbers((prev) => ({
      ...prev,
      [entry.childpart]: updatedBoxNumbers
    }));
    // Optionally scroll to the input field or highlight
  };

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
    setBoxNumbers({});
  };
  const handleMachineChange = (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
    setBoxNumbers({});
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
    setBoxNumbers({});
  };
  const handleBoxChange = (id, value) => {
    const serials = value.split(",").map(s => s.trim()).filter(Boolean);
    setBoxNumbers((prev) => ({
      ...prev,
      [id]: serials,
    }));
  };

  const fetchAssemblies = async () => {
    try {
      const response = await fetch(`https://api.hanoch.in/api/traceability-production-filter/?machine=${selectedMachine}&part=${selectedChildPart}&date=${selectedDate}&shift=${selectedShift}`, {
        headers: {
          //Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setSubmittedAssemblies(data); // ← adjust based on actual response shape
      } else {
        console.error("Failed to fetch assemblies");
      }
    } catch (error) {
      console.error("Fetch assemblies error:", error);
    }
  };

 const fetchUsedChildPartAssemblies = async () => {
    try {
      const response = await fetch(`https://api.hanoch.in/api/traceability/unused/${selectedChildPart}/?&date=${selectedDate}&shift=${selectedShift}`, {
        headers: {
          //Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setUnusedAssemblies(data); // ← adjust based on actual response shape
      } else {
        console.error("Failed to fetch assemblies");
      }
    } catch (error) {
      console.error("Fetch assemblies error:", error);
    }
  };
const handleSubmit = async (childPart) => {
  const boxList = boxNumbers[childPart.id] || [];

  if (boxList.length === 0) {
    console.warn("No box numbers selected for child part", childPart.id);
    return;
  }

  const payload = {
    machine: Number(selectedMachine),
    serial_number: boxList.join(","),   // 👈 still send comma-separated
    operator: Number(selectedOperator_id),
    childpart: childPart.id,
    child_part_name: childPart.description,
    part: selectedChildPart,
    date: selectedDate,
    shift: Number(selectedShift),
  };

  try {
    setIsLoading(true);
    const response = await fetch("https://api.hanoch.in/api/traceability-production/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to submit data for ${childPart.part_number}`);
    }

    console.log("Submitted successfully:", payload);

    // Clear selected boxes for this child
    setBoxNumbers((prev) => ({ ...prev, [childPart.id]: [] }));
    fetchAssemblies();
    fetchUsedChildPartAssemblies();
  } catch (err) {
    console.error("Submission error:", err);
  } finally {
    setIsLoading(false);
  }
};

const handlePartSubmit = async ({ partId, part_label }) => {
  if (!part_label || !part_label.trim()) {
    console.warn("No valid part label provided");
    return;
  }

  try {
    setIsLoading(true);
    const response = await fetch(
      `https://api.hanoch.in/api/readyforqc/?shift=${selectedShift}&date=${selectedDate}&operator_id=${selectedOperator_id}&part_id=${selectedChildPart}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({ part_label }),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update part ${partId}`);
    }

    const result = await response.json();
    console.log("Updated successfully:", result);

    // Clear input for that part
    setPartLabels((prev) => ({ ...prev, [partId]: "" }));

    // Refresh the list
    fetchUsedChildPartAssemblies();
  } catch (err) {
    console.error("Update error:", err);
  }finally{
    setIsLoading(false);
  }
};


  document.title = "Part Assembly | OptiMize ";
// Group unusedAssemblies by part id
const groupedAssemblies = unusedAssemblies.reduce((acc, curr) => {
  if (!acc[curr.part]) {
    acc[curr.part] = {
      part: curr.part,
      child_part_name: curr.child_part_name,
      serials: [],
      ids: []
    };
  }
  acc[curr.part].serials.push(curr.serial_number);
  acc[curr.part].ids.push(curr.id);
  return acc;
}, {});

const groupedArray = Object.values(groupedAssemblies);

// State for part labels
const [partLabels, setPartLabels] = useState({});
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Traceability production" />

          <div className="d-flex flex-wrap align-items-center mb-3"
            style={{
              gap: "12px",
              padding: "12px 16px",
              backgroundColor: "#252b3b",
              color: "#c9d1d9",
              borderRadius: "6px",
              width: "100%"
            }}>
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Select Machine:</label>
              <select
                className="form-control"
                id="machine"
                name="selectedMachine"
                value={selectedMachine || ""}

                onChange={handleMachineChange}
              >
                <option key="default">Select Machine</option>
                {machines?.map((machine, index) => (
                  <option key={index} value={machine.id}>
                    {machine.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={{
              backgroundColor: "#21262d",
              padding: "4px 10px",
              borderRadius: "6px",
              border: "1px solid #30363d"
            }}>
              <span style={{ fontWeight: "600", fontSize: "16px" }}>{selectedChildPart}</span>
            </div>

            {/* Shift Selector */}
            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Shift:</label>
              <select
                value={selectedShift}
                onChange={handleShiftChange}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#21262d",
                  color: "#c9d1d9",
                  border: "1px solid #30363d",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              >
                <option value="">Select shift</option>
                <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")}>6-2 (Shift 1)</option>
                <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
              </select>
            </div>

            <div className="d-flex align-items-center">
              <label style={{
                fontSize: "13px",
                marginRight: "6px",
                marginBottom: 0,
                color: "#8b949e"
              }}>Date:</label>
              <input
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
                max={new Date().toISOString().split('T')[0]}
                style={{
                  padding: "4px 8px",
                  backgroundColor: "#21262d",
                  color: "#c9d1d9",

                  border: "1px solid #30363d",
                  borderRadius: "6px",
                  fontSize: "13px"
                }}
              />
            </div>
          </div>
          <div>
            <h5>Traceability production Box number</h5>
            {isLoading ? (
              <p>Loading child parts...</p>
            ) : (
            
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ border: "1px solid", padding: "8px" }}>Child Part</th>
                    <th style={{ border: "1px solid", padding: "8px" }}>Box Number</th>
                    <th style={{ border: "1px solid", padding: "8px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {childPartData.map((child) => (
                    <tr key={child.id}>
                      <td style={{ border: "1px solid", padding: "8px" }}>{child.part_number} ({child.description})</td>
                      <td style={{ border: "1px solid", padding: "8px" }}>
                     <Select
  isMulti
  options={child.box_serials
    .filter(serial => !(boxNumbers[child.id] || []).includes(serial)) // 👈 remove already selected ones
    .map(serial => ({
      value: serial,
      label: serial
    }))
  }
  value={
    (boxNumbers[child.id] || []).map(serial => ({
      value: serial,
      label: serial
    }))
  }
  onChange={(selected) => {
    setBoxNumbers(prev => ({
      ...prev,
      [child.id]: selected.map(item => item.value)
    }));
  }}
  placeholder="Select box numbers"
  styles={{
    control: (base) => ({
      ...base,
      backgroundColor: "#21262d",
      borderColor: "#30363d",
      color: "#000000ff"
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#30363d",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#0b0b0bff"   // 👈 ensure visible
    }),
    menu: (base) => ({
      ...base,
      //  maxHeight: "300px", 
        //  overflowY: "auto",
      backgroundColor: "#161b22",
      color: "#315981ff"
    })
  }}
/>

                      
                        {/* <input
                          type="text"
                          value={boxNumbers[child.id] || ""}
                          onChange={(e) => {
                            setBoxNumbers(prev => ({
                              ...prev,
                              [child.id]: e.target.value
                            }));
                          }}
                          placeholder="Enter box numbers, comma separated"
                        /> */}
                      </td>
                      <td style={{ border: "1px solid", padding: "8px" }}>
                          {isLoading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
                        <button onClick={() => handleSubmit(child)} className="btn btn-primary waves-effect waves-light">Submit</button>
          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            )}
            {/* {submittedAssemblies.length > 0 && (
              <div style={{ marginTop: "2rem" }}>
                <h5 style={{ color: "#c9d1d9" }}>Submitted Traceability Assembly production</h5>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "2rem" }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid", padding: "8px" }}>Child Part</th>
                      <th style={{ border: "1px solid", padding: "8px" }}>Box Serials</th>
                      <th style={{ border: "1px solid", padding: "8px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {submittedAssemblies.map((entry) => (
                      <tr key={entry.id}>
                        <td style={{ border: "1px solid", padding: "8px" }}>{entry.child_part_name}</td>
                        <td style={{ border: "1px solid", padding: "8px" }}>
                          {Array.isArray(entry.box_serial_numbers)
                            ? entry.box_serial_numbers.join(", ")
                            : "No serials"}
                        </td>
                        <td style={{ border: "1px solid", padding: "8px" }}>
                          <button onClick={() => handleEdit(entry)} className="btn btn-primary waves-effect waves-light">Edit</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            )} */}


            {unusedAssemblies.length >0 && (
              <div style={{ marginTop: "2rem" }}>
 <h5 style={{ color: "#c9d1d9" }}>Enter Part label for Traceability Assembly production</h5>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "2rem" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid", padding: "8px" }}> Part</th>
                  <th style={{ border: "1px solid ", padding: "8px" }}>Box Serials</th>
                    <th style={{ border: "1px solid", padding: "8px" }}>Part Label</th>
                  <th style={{ border: "1px solid", padding: "8px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
          {groupedArray.map((group) => (
            <tr key={group.part}>
              <td style={{ border: "1px solid", padding: "8px" }}>{group.part}</td>
              <td style={{ border: "1px solid", padding: "8px" }}>
                {group.serials.join(", ")}
              </td>
              <td style={{ border: "1px solid", padding: "8px" }}>
                <input
                  type="text"
                  value={partLabels[group.part] || ""}
                  onChange={(e) =>
                    setPartLabels((prev) => ({
                      ...prev,
                      [group.part]: e.target.value
                    }))
                  }
                  placeholder="Enter part label(s)"
                  style={{ width: "100%" }}
                />
              </td>
              <td style={{ border: "1px solid", padding: "8px" }}>
               <button
  className="btn btn-primary waves-effect waves-light"
  onClick={() =>
    handlePartSubmit({
      partId: group.part,
      part_label: partLabels[group.part]
    })
  }
>
  Submit
</button>

              </td>
            </tr>
          ))}
        </tbody>
                 
                 
                  {/* <td style={{ border: "1px solid", padding: "8px" }}>
                    <input
                      type="text"
                      value={boxNumbers[selectedChildPart] || ""}
                      onChange={(e) => {
                            setBoxNumbers(prev => ({
                              ...prev,
                              [selectedChildPart]: e.target.value
                            }));
                          }}
                      placeholder="Enter box numbers, comma separated"
                    />


                  </td> */}
                  {/* <td style={{ border: "1px solid", padding: "8px" }}>
                    <button onClick={() => handlePartSubmit()} className="btn btn-primary waves-effect waves-light">Submit</button>
                  </td> */}
              
            </table>
</div>
            )}
            
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TraceabilityAssemblyProduction;
